/** Curated emoji sets for offline EmojiPicker — no CDN / no network. */

export interface EmojiCategory {
  id: string;
  label: string;
  emojis: string[];
}

export const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    id: "money",
    label: "Money",
    emojis: [
      "💰", "💵", "💴", "💶", "💷", "💸", "💳", "🏦", "📈", "📉",
      "📊", "💎", "🪙", "🏧", "💹", "🧾", "🧮", "⚖️", "🏛️", "💼",
    ],
  },
  {
    id: "home",
    label: "Home",
    emojis: [
      "🏠", "🏡", "🔑", "🛋️", "🛏️", "🚪", "🪟", "🛁", "🧹", "🧺",
      "🛠️", "🔧", "💡", "🔌", "📺", "🪴", "🌳", "🐕", "🐈", "📦",
    ],
  },
  {
    id: "food",
    label: "Food",
    emojis: [
      "🛒", "🍎", "🥗", "🍕", "🍜", "🍣", "☕", "🍺", "🧃", "🍰",
      "🥑", "🍞", "🧀", "🥚", "🍗", "🍔", "🌮", "🍦", "🍪", "🍽️",
    ],
  },
  {
    id: "life",
    label: "Life",
    emojis: [
      "🚌", "🚗", "✈️", "⛽", "🏥", "💊", "❤️", "🛡️", "🎓", "👶",
      "👕", "👟", "💄", "💇", "🎬", "🎮", "🎵", "📱", "💻", "🎁",
    ],
  },
  {
    id: "goals",
    label: "Goals",
    emojis: [
      "🎯", "⭐", "🌟", "✨", "🔥", "💪", "🏆", "🥇", "🚀", "🌈",
      "🌴", "🏖️", "⛺", "🎿", "💍", "💒", "🐕", "📷", "🎨", "📚",
    ],
  },
  {
    id: "faces",
    label: "Faces",
    emojis: [
      "😀", "😊", "😎", "🥳", "🤩", "😇", "🙂", "😌", "🤓", "🧐",
      "😺", "🐶", "🐱", "🦊", "🐻", "🐼", "🐨", "🐯", "🦁", "🐮",
    ],
  },
];

export const DEFAULT_EMOJI = "📦";
